import React, { useState } from 'react';
import { AdminPageHeader } from '../../components/admin/guidance';
import { HANDBOOK_SECTIONS } from '../../content/adminPlatformHandbook';

const toneClass = {
 info: 'border-border bg-surface-muted text-ink',
 warn: 'border-amber-200 bg-amber-50 text-amber-950',
};

const Block = ({ block }) => {
 if (block.type === 'h') {
 return (
 <h3 className="text-sm font-semibold text-ink pt-2">{block.text}</h3>
 );
 }
 if (block.type === 'p') {
 return <p className="text-sm leading-6 text-ink-secondary">{block.text}</p>;
 }
 if (block.type === 'note') {
 return (
 <p className={`rounded-xl border px-4 py-3 text-sm leading-6 ${toneClass[block.tone] || toneClass.info}`}>
 {block.text}
 </p>
 );
 }
 if (block.type === 'ul') {
 return (
 <ul className="list-disc pl-5 space-y-2 text-sm leading-6 text-ink-secondary">
 {block.items.map((item) => (
 <li key={item}>{item}</li>
 ))}
 </ul>
 );
 }
 if (block.type === 'table') {
 return (
 <div className="overflow-x-auto rounded-xl border border-border">
 <table className="min-w-full text-sm">
 <thead className="bg-surface-muted">
 <tr>
 {block.headers.map((header) => (
 <th
 key={header}
 className="px-3 py-2 text-left font-semibold text-ink"
 >
 {header}
 </th>
 ))}
 </tr>
 </thead>
 <tbody>
 {block.rows.map((row) => (
 <tr key={row.join('|')} className="border-t border-border">
 {row.map((cell) => (
 <td key={cell} className="px-3 py-2 align-top text-ink-secondary">
 {cell}
 </td>
 ))}
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 );
 }
 return null;
};

const AdminPlatformHandbook = () => {
 const [activeId, setActiveId] = useState(HANDBOOK_SECTIONS[0].id);

 const jump = (id) => {
 setActiveId(id);
 const node = document.getElementById(id);
 if (node) node.scrollIntoView({ behavior: 'smooth', block: 'start' });
 };

 return (
 <div className="space-y-6">
 <AdminPageHeader
 title="Platform handbook"
 subtitle="How clients, vendors, and admin share one marketplace: markets, tax, and how vendors are paid — including countries where Stripe Connect is not available."
 />

 <div className="grid grid-cols-1 lg:grid-cols-[16rem_minmax(0,1fr)] gap-6 items-start">
 <nav className="lg:sticky lg:top-4 rounded-lg border border-border bg-surface p-3">
 <p className="px-2 pb-2 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
 Contents
 </p>
 <ul className="space-y-0.5">
 {HANDBOOK_SECTIONS.map((section) => (
 <li key={section.id}>
 <button
 type="button"
 onClick={() => jump(section.id)}
 className={`w-full text-left rounded-lg px-2 py-1.5 text-sm ${ activeId === section.id ? 'bg-gray-900 text-white' : 'text-gray-700 hover:bg-gray-100' }`}
 >
 {section.title}
 </button>
 </li>
 ))}
 </ul>
 </nav>

 <div className="space-y-5">
 {HANDBOOK_SECTIONS.map((section) => (
 <section
 key={section.id}
 id={section.id}
 className="scroll-mt-4 rounded-lg border border-border bg-surface p-5 sm:p-6 space-y-3"
 >
 <h2 className="text-lg font-semibold text-ink">{section.title}</h2>
 {section.summary ? (
 <p className="text-sm text-ink-tertiary">{section.summary}</p>
 ) : null}
 {section.blocks.map((block, index) => (
 <Block key={`${section.id}-${index}`} block={block} />
 ))}
 </section>
 ))}
 </div>
 </div>
 </div>
 );
};

export default AdminPlatformHandbook;
